<div class="card" *ngIf="processo$ | async as proc">
  <div class="flex align-items-center justify-content-between mb-4">
    <div class="flex align-items-center">
      <p-button icon="pi pi-arrow-left" styleClass="p-button-text p-button-secondary mr-2" (onClick)="voltar()"></p-button>
      <app-header
        [titulo]="'Monitor: ' + proc.nome"
        [descricao]="proc.descricao">
      </app-header>
    </div>
    <p-tag [value]="proc.ativo ? 'ATIVO' : 'INATIVO'" [severity]="proc.ativo ? 'success' : 'danger'"></p-tag>
  </div>

  <div class="grid">
    <!-- Estatísticas de Recebimento -->
    <div class="col-12 md:col-4">
      <p-card header="Recebimento (Inbound)">
        <div class="flex flex-column gap-3">
          <div class="flex justify-content-between">
            <span class="text-500">Total Recebido</span>
            <span class="font-bold text-xl">{{ proc.estatisticas.registrosRecebidos.total }}</span>
          </div>
          <div class="flex justify-content-between text-green-600">
            <span>Concluídos</span>
            <span class="font-bold">{{ proc.estatisticas.registrosRecebidos.concluido }}</span>
          </div>
          <div class="flex justify-content-between text-red-600">
            <span>Falhas</span>
            <span class="font-bold">{{ proc.estatisticas.registrosRecebidos.erro }}</span>
          </div>
          <div class="flex justify-content-between text-orange-600">
            <span>Pendentes</span>
            <span class="font-bold">{{ proc.estatisticas.registrosRecebidos.pendente }}</span>
          </div>
          <p-button label="Ver Registros Recebidos" icon="pi pi-list" styleClass="mt-2 w-full" (onClick)="navegarParaRegistros('recebidos')"></p-button>
        </div>
      </p-card>
    </div>

    <!-- Estatísticas de Visualização -->
    <div class="col-12 md:col-4">
      <p-card header="Visualização (Transformados)">
        <div class="flex flex-column gap-3">
          <div class="flex justify-content-between">
            <span class="text-500">Total Transformado</span>
            <span class="font-bold text-xl">{{ proc.estatisticas.registrosVisualizacao.total }}</span>
          </div>
          <div class="flex justify-content-between text-green-600">
            <span>Integrados</span>
            <span class="font-bold">{{ proc.estatisticas.registrosVisualizacao.integrado }}</span>
          </div>
          <div class="flex justify-content-between text-red-600">
            <span>Erros</span>
            <span class="font-bold">{{ proc.estatisticas.registrosVisualizacao.erro }}</span>
          </div>
          <div class="flex justify-content-between text-orange-600">
            <span>Pendentes</span>
            <span class="font-bold">{{ proc.estatisticas.registrosVisualizacao.pendente }}</span>
          </div>
          <p-button label="Ver Registros Visualização" icon="pi pi-table" styleClass="mt-2 w-full" severity="secondary" (onClick)="navegarParaRegistros('visualizacao')"></p-button>
        </div>
      </p-card>
    </div>

    <!-- Estatísticas de Publicação -->
    <div class="col-12 md:col-4">
      <p-card header="Publicação (API/Access)">
        <div class="flex flex-column gap-3">
          <div class="flex justify-content-between">
            <span class="text-500">Total de Registros</span>
            <span class="font-bold text-xl">{{ proc.estatisticas.registrosPublicacao.total }}</span>
          </div>
          <div class="flex justify-content-between text-blue-600">
            <span>Total de Acessos</span>
            <span class="font-bold text-xl">{{ proc.estatisticas.registrosPublicacao.totalAcessos }}</span>
          </div>
          <div class="mt-4">
            <span class="text-500 block mb-1">Último Acesso:</span>
            <span class="font-bold" *ngIf="proc.estatisticas.registrosPublicacao.ultimoAcesso">
              {{ proc.estatisticas.registrosPublicacao.ultimoAcesso | date:'dd/MM/yyyy HH:mm:ss' }}
            </span>
            <span class="font-bold italic" *ngIf="!proc.estatisticas.registrosPublicacao.ultimoAcesso">Nunca acessado</span>
          </div>
          <p-button label="Configurar Publicação" icon="pi pi-globe" styleClass="mt-auto w-full" severity="info" [disabled]="true"></p-button>
        </div>
      </p-card>
    </div>
  </div>
</div>
